"use strict";

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _debounce = _interopRequireDefault(require("lodash/debounce"));

var _input = _interopRequireDefault(require("../input"));

var _style = _interopRequireDefault(require("./style"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var ColorInput = function ColorInput(_ref) {
  var pickerLabel = _ref.pickerLabel,
      inputLabel = _ref.inputLabel,
      value = _ref.value,
      onChange = _ref.onChange;

  var _ref2 = (0, _react.useState)(value),
      _ref3 = _slicedToArray(_ref2, 2),
      color = _ref3[0],
      setColor = _ref3[1];

  var onChangeDebounced = (0, _react.useCallback)((0, _debounce["default"])(onChange, 500), [onChange]);
  var onChangeColor = (0, _react.useCallback)(function (_ref4) {
    var target = _ref4.target;
    var value = target.value.trim();
    var isValid = /^#[0-9A-Fa-f]{6}$/.test(value);
    setColor(value);

    if (isValid) {
      onChangeDebounced(value);
    }
  }, [setColor, onChangeDebounced]);
  return _react["default"].createElement(_style["default"], null, _react["default"].createElement(_input["default"], {
    type: "color",
    "aria-label": pickerLabel,
    value: color,
    onChange: onChangeColor
  }), _react["default"].createElement(_input["default"], {
    type: "text",
    "aria-label": inputLabel,
    pattern: "#[0-9A-Fa-f]{6}",
    value: color,
    onChange: onChangeColor
  }));
};

ColorInput.propTypes = {
  pickerLabel: _propTypes["default"].string.isRequired,
  inputLabel: _propTypes["default"].string.isRequired,
  value: _propTypes["default"].string.isRequired,
  onChange: _propTypes["default"].func.isRequired
};
var _default = ColorInput;
exports["default"] = _default;